import React from "react";
import { Navigate } from "react-router-dom";
import { getCookie } from "../../utils/cookies";

// Mock authentication function
const isAuthenticated = () => {
  return getCookie("ssoToken");
};
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
